import { t } from 'i18next'
import { SelectDataType } from '~/components/EFSelect/EFSelect.model'
import { CertificatePurpose, infrastructureCertificatePurposeTranslationKey } from '~/models/server/InfrastructureCertificatePurpose'

export const DISPLAY_TYPE_DEVICE_FILTER = [
  { name: 'Draft Values', value: 'draft' },
  { name: 'Approved Values', value: 'approved' },
  { name: 'Current Values', value: 'current' }
] as SelectDataType[]

export const CONDITION_DEVICE_FILTER = [
  { name: '<em>None</em>', value: '' },
  { name: 'Changed', value: 'modifiedOnly' },
  { name: 'Duplicates', value: 'duplicatesOnly' },
  { name: 'Empty Values', value: 'emptyOnly' },
  { name: 'Latest Version', value: 'latestVersionOnly' },
  { name: 'Mandatory Version', value: 'mandatoryVersionOnly' },
  { name: 'Out of Date', value: 'outOfDateOnly' }
] as SelectDataType[]

export const OTAP_STATES_FILTER = [
  { name: 'All', value: 'All' },
  { name: 'Any required Feature License Keys Missing ', value: 4 },
  { name: 'Available for OTAP', value: 7 },
  { name: 'Boot Code Bug must Approve with Correct Firmware', value: 15 },
  { name: 'Boot Code Bug No Solution', value: 14 },
  {
    name: 'Current and/or approved firmware does not support OTAP of firmware ',
    value: 3
  },
  { name: 'Device does not have an OTAP feature license', value: 11 },
  { name: 'Device firmware does not support OTAP ', value: 10 },
  { name: 'Device has some observed state', value: 12 },
  { name: 'Device ID conflict ', value: 2 },
  { name: 'Generation error', value: 6 },
  { name: 'Initiated', value: 8 },
  { name: 'No observed state', value: 0 },
  { name: 'OTAP error', value: 9 },
  {
    name: 'The device contains firmware components that are not supported by OTAP',
    value: 13
  },
  { name: 'Up to date - OTAP supported ', value: 1 }
] as SelectDataType[]

export const FIELD_TYPE_OPTIONS = [
  { name: 'Single-Line Text', value: 'Single-Line Text' },
  { name: 'Numeric', value: 'Numeric' },
  { name: 'List', value: 'List' },
  { name: 'Multi-Line Text', value: 'Multi-Line Text' },
  { name: 'Password', value: 'Password' },
  { name: 'Asset SerialNumber', value: 'Asset SerialNumber' },
  { name: 'IPv4 Address', value: 'IPv4 Address' },
  { name: 'From Field Ref', value: 'From Field Ref' }
] as SelectDataType[]

export const CLIENT_ACCESS_TYPE_OPTIONS = [
  { name: 'Editable', value: 'Editable' },
  { name: 'None', value: 'None' },
  { name: 'Readonly', value: 'Readonly' }
]

export const OTAP_REGISTRATIONS_FILTERS = [
  { name: '<em>None</em>', value: '' },
  { name: 'Latest Version', value: 'latestVersionOnly' },
  { name: 'Mandatory Version', value: 'mandatoryVersionOnly' },
  { name: 'Out of Date', value: 'outOfDateOnly' }
]

export const INFRASTRUCTURE_CERTIFICATE_PURPOSE_OPTIONS = [
  {name : `${t(infrastructureCertificatePurposeTranslationKey(CertificatePurpose.TLSServerIdentity))}`, value : CertificatePurpose.TLSServerIdentity},
  {name : `${t(infrastructureCertificatePurposeTranslationKey(CertificatePurpose.ServerTrust))}`, value : CertificatePurpose.ServerTrust},
  {name : `${t(infrastructureCertificatePurposeTranslationKey(CertificatePurpose.ClientAuthentication))}`, value : CertificatePurpose.ClientAuthentication}
]